function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "bookmark_svg__a",
  d: "M14 17.057V3a1 1 0 00-1-1H3a1 1 0 00-1 1v14.057l5.419-3.87a1 1 0 011.162 0L14 17.056zm-6-1.828l-6.419 4.585A1 1 0 010 19V3a3 3 0 013-3h10a3 3 0 013 3v16a1 1 0 01-1.581.814L8 15.229z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(4 2)"
}, React.createElement("mask", {
  id: "bookmark_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#bookmark_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#bookmark_svg__a"
}), React.createElement("g", {
  fill: "#22272F",
  mask: "url(#bookmark_svg__b)"
}, React.createElement("path", {
  d: "M-4-2h24v24H-4z"
})));

var SvgBookmark = function SvgBookmark(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/bookmark.289f8ce6.svg";
export { SvgBookmark as ReactComponent };